import React, { useContext } from 'react'
import UserContext from 'shared/components/context/user'
import SuggestedTags from 'shared/components/suggested-tags'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationTool from '../../../types/creation-tool'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import { CreationToolUploadContext } from '../manager'

const Container = styled(UploadFieldBlock as any)`
    grid-column: span 4;

    > div {
        margin-bottom: 0;
    }
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadSuggestedTagsField = ({ className }: Props) => {
    const { user } = useContext(UserContext)
    const { tool } = useContext(CreationToolsContext)
    const { tags, lastEnteredTags, addTags } = useContext(CreationToolUploadContext)
    const endpoint = CreationTool.suggestedTagsEndpoint(tool)

    return (
        <Container className={className}>
            <SuggestedTags
                {...{
                    currentTags: tags,
                    lastEnteredTags,
                    endpoint,
                    gifID: '',
                    addSugTag: (tag: string, isSuggested: boolean) => addTags([tag], isSuggested),
                    isVertical: false,
                    userName: user.username,
                }}
            />
        </Container>
    )
}

export default CreationUploadSuggestedTagsField
